import { z } from "zod";

/**
 * Ask Argus request schema — POST /api/v1/ecosystem/query
 * Source of truth: CLAUDE.md Section 20.6
 */
export const AskArgusRequestSchema = z.object({
  query: z.string().min(1).max(10000),
  conversationId: z.string().uuid().nullable().default(null),
  context: z.object({
    tenantId: z.string().uuid(),
    userId: z.string().uuid(),
    userRole: z.string(),
    locale: z.string().default("en"),
  }).optional(),
  options: z.object({
    model: z.enum(["default", "fast", "precise"]).default("default"),
    ragEnabled: z.boolean().default(true),
    maxTokens: z.number().int().positive().optional(),
  }).optional(),
});

export type AskArgusRequest = z.infer<typeof AskArgusRequestSchema>;

export const IntentClassificationSchema = z.enum([
  "rag_only",
  "mcp_only",
  "hybrid",
  "conversational",
  "clarification_needed",
  "tool_use",
  "direct_answer",
]);

export type IntentClassification = z.infer<typeof IntentClassificationSchema>;
